module.exports = {
  main_settings: 'Основные настройки',
  preset: 'Пресет',
  metrics: 'Метрики',
  project_records: 'Записи проекта',
  reports: 'Отчеты',
  triggers: 'Триггеры',
};
